"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRICE_TEMPLATE = exports.PRICE_PREFIX = exports.NON_BREAKING_SPACE = exports.DEFAULT_LOCALE = exports.DECIMAL_TYPE = exports.CURR_DISPLAY = exports.ARR_PRICE_TEMPLATE = exports.ARR_PRICE_PREFIX = exports.ARR_DECIMAL_TYPE = void 0;
var DECIMAL_TYPE = {
  FLOAT: 'FLOAT',
  ROUND: 'ROUND',
  FLOOR: 'FLOOR',
  CEIL: 'CEIL'
};
exports.DECIMAL_TYPE = DECIMAL_TYPE;
var PRICE_TEMPLATE = {
  DEFAULT: 'DEFAULT',
  TEMPLATE2: 'TEMPLATE2',
  TEMPLATE3: 'TEMPLATE3'
};
exports.PRICE_TEMPLATE = PRICE_TEMPLATE;
var PRICE_PREFIX = {
  ADD: '+',
  SUBTRACT: '-',
  MULTIPLY: 'x',
  DIVIDE: '/',
  FROM: 'From'
};
exports.PRICE_PREFIX = PRICE_PREFIX;
var ARR_DECIMAL_TYPE = Object.keys(DECIMAL_TYPE);
exports.ARR_DECIMAL_TYPE = ARR_DECIMAL_TYPE;
var ARR_PRICE_TEMPLATE = Object.keys(PRICE_TEMPLATE);
exports.ARR_PRICE_TEMPLATE = ARR_PRICE_TEMPLATE;
var ARR_PRICE_PREFIX = Object.keys(PRICE_PREFIX);
exports.ARR_PRICE_PREFIX = ARR_PRICE_PREFIX;
var NON_BREAKING_SPACE = '\xa0';
exports.NON_BREAKING_SPACE = NON_BREAKING_SPACE;
var CURR_DISPLAY = {
  SYMBOL: 'symbol',
  CODE: 'code',
  NARROW_SYMBOL: 'narrowSymbol',
  NAME: 'name'
};
exports.CURR_DISPLAY = CURR_DISPLAY;
var DEFAULT_LOCALE = 'en-GB'; // export const DECIMALTYPES = ['FLOAT', 'ROUND', 'FLOOR', 'CEIL'];

exports.DEFAULT_LOCALE = DEFAULT_LOCALE;